import actions from "@/store/modules/settings/actions";
import mutations from "@/store/modules/settings/mutations";
import getters from "@/store/modules/settings/getters";

const state = {
  organisationUsers: [],
  isFetchingUsers: false
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
